export let medalAvatar = {
	bindings: {
		activity: '<',
	},
	template    : `<span class="icon i-28 md-avatar" ng-class="vm.medalAvatar(vm.activity)"><md-tooltip class="custom-tooltip" md-direction="right">{{vm.Medal}}</md-tooltip></span>`,
	controllerAs: 'vm',
	controller  : [ 'CssClasses', '$stateParams',
		function medalAvatarCtrl (CssClasses, $stateParams) {
			const vm = this
			const textColor = CssClasses.textColor
			const icons = CssClasses.icons
			const currentStage = ($stateParams.currentStage) ? $stateParams.currentStage : $stateParams.stage

			vm.medalAvatar = medalAvatar
			vm.Medal = ''

			function medalAvatar (activity) {
				if (currentStage === 'review') {
					if (activity.isFeedbackActivity === 1) {
						vm.Medal = 'Ajuste en retroalimentación'

						return [ textColor.green, icons.feedback ]
					}
				} else {
					if (activity.origin === 2) {
						vm.Medal = 'Agregada en ejecución'

						return [ textColor.yellow, icons.important ]
					} else if (activity.origin === 3) {
						vm.Medal = 'Agregada en ejecución (externo)'

						return [ textColor.orange, icons.important ]
					} else if (activity.origin != 1 && activity.origin != 2 && activity.origin != 3) {
						vm.Medal = 'Actividad no revisada'

						return [ textColor.black, icons.important ]
					}
				}
			}
		},
	] }



// WEBPACK FOOTER //
// ./src/app/u-faculty/components/activities-review/activities-list/medal-avatar.js